import React, { useEffect, useState, useCallback } from "react";
//import { useFocusEffect } from '@react-navigation/native';
import { View, StyleSheet, TextInput, Alert, FlatList, TouchableOpacity, Text } from 'react-native';
import defaultStyles from "../config/styles";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import colors from '../config/colors';
import connectionConfig from "../config/settings";
import configurationPost from '../config/configurationPost';
//import settingStorage from "../config/settingStorage";
import { ListItemAccount, ListItemSeparator } from "../components/lists";
import routes from '../navigation/routes';
import ActivityIndicator from '../components/ActivityIndicator';
//import AsyncStorage from "@react-native-async-storage/async-storage";
//import useAuth from "../auth/useAuth";

function ChatUserListScreen(props) {
    const [searchUserFailed, setSearchUserFailed] = useState(false)
    const [items, setItems] = useState([])
    const [searchUser, setSearchUser] = useState(false)
    const [loading, setLoading] = useState(false);
 //   const {user} = useAuth()
    var itemsValidation = []
    var profileUri = connectionConfig.imageUrl + '/PerfilDeUsuario/'

    useEffect(() => {
    getFollowed()  
    }, [])
    
    //---------------------------------------------
    //Va a servidor por la lista de seguidos
    //---------------------------------------------
    const getFollowed = async () => {
        setLoading(true)
        // debugger
        var post_values = {
            //userId : props.route.params.userIdListing
            userId: props.route.params.userIdListing

        }
        configurationPost.body = JSON.stringify(post_values)
        await fetch(connectionConfig.apiUrl + '/fixoUsers/SelectFollowed/', configurationPost)
            .then(response => response.json())
            .then(response => {
                setItems(response.data)
                setLoading(false)
                // console.log('select regresa', response)
            })
            .catch(err => {
                console.log('fixo failed :( review internet service -> /fixoUsers/SelectFollowed/', err)
            })
    }
    const onChangeText = async (text) => {
        setSearchUser(false)
        setItems([])
        setLoading(true)
        var post_values = {
            textUser: text.nativeEvent.text,
        }
        configurationPost.body = JSON.stringify(post_values)
        //solicita el servicio para login fixo remoto
        await fetch(connectionConfig.apiUrl + '/searchUserFixo/select/', configurationPost)
            .then(response => response.json())
            .then(response => {
                //  debugger
                setItems(response.data)
                setLoading(false)
                itemsValidation = response.data
                //items = Array.from(response.data)
                //items = JSON.parse(items)
                setSearchUser(true)
            })
            .catch(err => {
                console.log('searchUser failed :( review internet service /searchUserFixo/select/', err)
                setSearchUserFailed(true);
            })
        if (searchUserFailed === false) {
            if (itemsValidation.length === 0 || items === 'error en query') {
                Alert.alert("Notification", "User doesn't exists in fixo.");
            }
        }
    }

    return (
        <View style={styles.container}>
            <View style={styles.containerSearch}>
                <View style={styles.title}>
                    <Text style={styles.title}

                    >
                        Chats
                    </Text>
                </View>
            </View>
            <View style={styles.containerSearch}>
                <MaterialCommunityIcons
                    name={"account-search-outline"}
                    size={35}
                    color={defaultStyles.colors.medium}
                    style={styles.icon}
                />
                <TextInput style={styles.input}
                    onChange={text => onChangeText(text)}
                ></TextInput>
            </View>

            <ActivityIndicator visible={loading} />

            <FlatList
                data={items}
                keyExtractor={(items) => items.userId.toString()}
                renderItem={({ item, index }) => (
                    <ListItemAccount
                        image={profileUri + item.userId + '_' + item.userPhoto}
                        titleRol={item.userName}
                        onPress={() => {
                            // console.log('hola', index)
                            //debugger
                            // settingStorage.json.userId = item.userId
                            // console.log("id->", item.userId )
                            // AsyncStorage.setItem(settingStorage.KEY, JSON.stringify(settingStorage.json)) 
                            props.navigation.navigate(routes.CHAT, { item, index })
                        }}
                    >
                    </ListItemAccount>
                )}>
            </FlatList>

        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,

    },
    containerSearch: {
        //alignItems:"center",
        // alignContent:"center",
        //alignSelf:"center",
        marginTop: "5%",
        flexDirection: "row",
        width: "100%",
        height: "10%"
    },
    input: {
        borderWidth: 1,
        borderColor: colors.medium,
        paddingLeft: 5,
        borderRadius: 5,
        width: "80%",
    },
    icon: {
        alignSelf: "center",
        margin: 10,
        width: "10%",
    },
    title: {
        //alignContent:"center",
        //alignItems:"center",
        alignSelf: "center",
        margin: 0,
        fontSize: 30,
    }
})

export default ChatUserListScreen;